export const getPremiumUpgradePageUrl = _ref => {
  let {
    appDefId,
    siteGuid
  } = _ref;
  return `https://manage.wix.com/wix/api/premiumStart?appDefId=${appDefId}&siteGuid=${siteGuid}&businessTab=true`;
};
//# sourceMappingURL=index.js.map